import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { styled } from '@mui/material/styles';

export const FallbackIconStyled = styled(DoNotDisturbAltIcon)(({ theme }) => ({
  color: theme.palette.error.light,
}));
